export default __webpack_public_path__ + "assets/icons/excel-icon.e7149a8f.svg";